module.exports = __webpack_public_path__ + "static/media/2.5fb4e9e9.JPG";